import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const BUYER_AB_TEST_NAME = 'buyerAISupport_May2026';
const SELLER_AB_TEST_NAME = 'sellerAISupport_May2026';

function isBuyerAISupportTestVariant(): boolean {
    return getAbTestV2(BUYER_AB_TEST_NAME)?.variant === 'variant';
}

function isSellerAISupportTestVariant(): boolean {
    return getAbTestV2(SELLER_AB_TEST_NAME)?.variant === 'variant';
}

function isAISupportTestVariant({ isSellerChat }: { isSellerChat: boolean }): boolean {
    return isSellerChat ? isSellerAISupportTestVariant() : isBuyerAISupportTestVariant();
}

function trackBuyerAISupportTestVariant(): void {
    trackAbTestV2Variant(BUYER_AB_TEST_NAME);
}

function trackSellerAISupportTestVariant(): void {
    trackAbTestV2Variant(SELLER_AB_TEST_NAME);
}

function trackAISupportTestVariant({ isSellerChat }: { isSellerChat: boolean }): void {
    return isSellerChat ? trackSellerAISupportTestVariant() : trackBuyerAISupportTestVariant();
}

export { isAISupportTestVariant, trackAISupportTestVariant };
